import classnames from 'classnames'
import { ReactNode, useState } from 'react'

import { Button, IconChevronLeft, IconChevronRight } from '@/components'

interface CarouselProps {
    items: ReactNode[]
    className?: string
}

export const Carousel = ({
    items,
    className
}: CarouselProps) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    const nextSlide = () => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % items.length)
    }

    const prevSlide = () => {
        setCurrentIndex(prevIndex => prevIndex === 0 ? items.length - 1 : prevIndex - 1)
    }

    return <div className={classnames('px-3 lg:px-6', className)}>
        <div className="relative overflow-hidden shadow rounded-lg border border-gray-100">
            <div
                className="flex transition-transform duration-500"
                style={{
                    transform: `translateX(-${currentIndex * (100 / items.length)}%)`,
                    width: `${items.length * 100}%`
                }}
            >
                {items.map((item, index) => <div
                    key={index}
                    className="flex-shrink-0 w-full"
                    style={{ flexBasis: `${100 / items.length}%` }}
                >
                    {item}
                </div>)}
            </div>
            <button
                onClick={prevSlide}
                aria-label="Previous Slide"
                type="button"
                className="cursor-pointer absolute w-1/2 h-full top-0 left-0 bg-linear-to-r to-40% from-gray-200
                    transition-opacity opacity-0 hover:opacity-100"
            />
            <button
                onClick={nextSlide}
                aria-label="Next Slide"
                type="button"
                className="cursor-pointer absolute w-1/2 h-full top-0 right-0 bg-linear-to-l to-40% from-gray-200
                    transition-opacity opacity-0 hover:opacity-100"
            />
        </div>

        <div className="flex gap-4 lg:gap-8 items-center justify-center mt-6">
            <Button
                design="btn-link-gray"
                onClick={prevSlide}
                type="button"
                aria-label="Previous Slide"
            >
                <IconChevronLeft/>
            </Button>
            <div className="flex gap-2 lg:gap-4">
                {items.map((_, index) => <button
                    type="button"
                    key={index}
                    className={classnames(
                        'w-2 h-2 rounded-full cursor-pointer',
                        index <= currentIndex ? 'bg-brand-orange' : 'bg-orange-50 border border-gray-750'
                    )}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Go to slide ${index + 1}`}
                />)}
            </div>
            <Button
                design="btn-link-gray"
                onClick={nextSlide}
                type="button"
                aria-label="Next Slide"
            >
                <IconChevronRight/>
            </Button>
        </div>
    </div>
}
